/* eslint-disable no-console */
/* global edac_script_vars, jQuery, ajaxurl */
( function( $ ) {
	'use strict';

	const DEBUG_ENABLED = false;

	// eslint-disable-next-line no-unused-vars
	function debug( $message ) {
		if ( DEBUG_ENABLED ) {
			if ( typeof $message !== 'object' ) {
				console.debug( 'DEBUG: ' + $message );
			} else {
				console.debug( $message );
			}
		}
	}

	$( window ).on( 'load', function() {
		// log ignore on click
		$(
			'.edacp-results-table .edac-details-rule-records-record-actions-ignore'
		).click( function() {
			const id = $( this ).data( 'id' );
			$( '#edac-details-rule-records-record-' + id ).slideToggle();
		} );

		// add classes to log pagination
		$( '.edacp-log-pagination .page-numbers li' ).each( function() {
			const $this = $( this );
			$( '.page-numbers', $this ).addClass( 'button' );
		} );

		// bulk ignore select on change set bulk ignore submit to enabled
		$( '.edacp-bulk-ignore-select' ).change( function() {
			if ( $( this ).val() !== -1 ) {
				$( '.edacp-bulk-ignore-submit' ).prop( 'disabled', false );
			}
		} );

		// bulk ignore submit button set as disabled on load
		$( '.edacp-bulk-ignore-submit' ).prop( 'disabled', true );

		// bulk ignore
		$( '.edacp-bulk-ignore-submit' ).click( function() {
			//var count = 0;
			const checked = $( '.edacp-bulk-ignore-checkbox:checked' );
			const select = $( '.edacp-bulk-ignore-select' ).val();

			const ignoreAction = select;
			const ignoreType = null;
			const comment = 'Bulk Ignore';
			const ignoreGlobal = 0;
			const ids = [];

			$( '.edacp-bulk-ignore-submit' ).prop( 'disabled', true );

			checked.each( function() {
				ids.push( $( this ).val() );
			} );

			edacpInsertIgnoreData(
				ids,
				ignoreAction,
				ignoreType,
				ignoreGlobal,
				comment,
				null
			);
		} );

		// fast track
		$( '.edacp-fast-track-table-actions-edit' ).click( function() {
			const id = $( this ).data( 'id' );
			const $button = $( this );
			const $buttonText = $( 'span:last-child', $button );
			const $icon = $( '.dashicons', $button );
			const $content = $( '#edacp-fast-track-table-rules-' + id );

			$content.slideToggle();

			if ( $button.attr( 'aria-expanded' ) === 'false' ) {
				$buttonText.html( 'Hide Issues' );
				$icon.removeClass( 'dashicons-arrow-down-alt2' ).addClass( 'dashicons-arrow-up-alt2' );
				$button.attr( 'aria-expanded', 'true' );
			} else {
				$buttonText.html( 'Review Issues' );
				$icon.removeClass( 'dashicons-arrow-up-alt2' ).addClass( 'dashicons-arrow-down-alt2' );
				$button.attr( 'aria-expanded', 'false' );
			}
		} );

		$( '.edacp-fast-track-table-rules-table-pages-view' ).click( function() {
			const id = $( this ).data( 'id' );
			const $list = $( '#edacp-fast-track-table-rules-table-pages-list-' + id );
			const $span = $( 'span:last-child', $( this ) );
			const isExpanded = $( this ).attr( 'aria-expanded' ) === 'true';

			$list.slideToggle();
			$( this ).attr( 'aria-expanded', ! isExpanded );

			// eslint-disable-next-line no-unused-expressions
			isExpanded
				? $span.html( 'View Pages' )
				: $span.html( 'Hide Pages' );
			$( '.dashicons', $( this ) ).toggleClass( 'dashicons-visibility' );
			$( '.dashicons', $( this ) ).toggleClass( 'dashicons-no-alt' );
		} );

		// bulk ignore
		$( '.edacp-fast-track-table-rules-table-actions-ignore' ).click(
			function() {
				const $this = $( this );
				const id = $this.data( 'id' );
				let ids = $this.data( 'ids' );
				if ( typeof ids === 'string' ) {
					ids = [ ids.slice( 1, -1 ) ];
				}
				const ignoreAction = $this.data( 'action' );
				const rowID = $this.data( 'row-id' );
				const comment = 'Global Ignore';
				const ignoreType = null;
				const ignoreGlobal = 1;
				const largeBatch = $this.data( 'large-batch' );

				$this.prop( 'disabled', true );

				jQuery.post(
					ajaxurl,
					{
						action: 'edacp_global_ignore_ajax',
						id,
						ids,
						ignore_action: ignoreAction,
					},
					function( response ) {
						let data = response;
						data = JSON.parse( data );
						if ( data ) {
							if (
								data.results &&
								data.ignore_action === 'enable'
							) {
								$(
									'.edacp-fast-track-table-rules-table-actions-ignore-label',
									$this
								).html( 'Stop Global Ignore' );
								$( '.dashicons', $this ).removeClass(
									'dashicons-visibility'
								);
								$( '.dashicons', $this ).addClass(
									'dashicons-hidden'
								);
								$this.data( 'action', 'disable' );
								$this.addClass( 'active' );
							} else {
								$(
									'.edacp-fast-track-table-rules-table-actions-ignore-label',
									$this
								).html( 'Global Ignore' );
								$( '.dashicons', $this ).addClass(
									'dashicons-visibility'
								);
								$( '.dashicons', $this ).removeClass(
									'dashicons-hidden'
								);
								$this.data( 'action', 'enable' );
								$this.removeClass( 'active' );
							}
						}

						//$this.prop("disabled",false);
					}
				);

				edacpInsertIgnoreData(
					ids,
					ignoreAction,
					ignoreType,
					ignoreGlobal,
					comment,
					rowID,
					largeBatch
				);
			}
		);

		function edacpInsertIgnoreData(
			ids,
			ignoreAction,
			ignoreType,
			ignoreGlobal,
			comment,
			rowID,
			largeBatch = false,
		) {
			$.ajax( {
				url: ajaxurl,
				method: 'GET',
				data: {
					action: 'edac_insert_ignore_data',
					ids,
					comment,
					ignore_action: ignoreAction,
					ignore_type: ignoreType,
					ignore_global: ignoreGlobal,
					// eslint-disable-next-line camelcase
					nonce: edac_script_vars.nonce,
					largeBatch,
				},
			} ).done( function( response ) {
				if ( true === response.success ) {
					// eslint-disable-next-line no-unused-vars
					const data = $.parseJSON( response.data );

					if ( ignoreGlobal === 0 ) {
						window.location.reload( true );
					} else if ( ignoreGlobal === 1 ) {
						// calculate rules count
						let rulesCount = $(
							'tr[data-row-id="' +
							rowID +
							'"] .edacp-fast-track-table-rules-count'
						).html();

						if (
							$(
								'.accessibility-checker_page_accessibility_checker_issues'
							).length
						) {
							if ( ignoreAction === 'enable' ) {
								rulesCount--;
							} else {
								rulesCount++;
							}
						} else if ( ignoreAction === 'enable' ) {
							rulesCount++;
						} else {
							rulesCount--;
						}

						$(
							'tr[data-row-id="' +
							rowID +
							'"] .edacp-fast-track-table-rules-count'
						).html( rulesCount );

						/* if(rulesCount === 0){
              $('*[data-row-id="'+rowID+'"]').fadeOut('fast',function(){
                location.reload(true);
              });
            } */
					}

					// make ignore button active again
					$(
						'.edacp-fast-track-table-rules-table-actions-ignore[data-row-id="' +
						rowID +
						'"]'
					).prop( 'disabled', false );
				} else {
					console.log( response );
				}
			} );
		}

		if ( $( '.edacp-rule-select' ).length ) {
			$( '.edacp-rule-select' ).on( 'change', function() {
				const url = $( this ).val();
				if ( url ) {
					window.location = url;
				}
			} );
		}

		if ( $( '.edacp-fast-track-type-select' ).length ) {
			$( '.edacp-fast-track-type-select' ).on( 'change', function() {
				const url = $( this ).val();
				if ( url ) {
					window.location = url;
				}
			} );
		}
	} );
}( jQuery ) );

// eslint-disable-next-line no-unused-vars
const postData = async ( url = '', data = {} ) => {
	const response = await fetch( url, {
		method: 'POST',
		body: JSON.stringify( data ),
	} );
	return response.json();
};

window.onload = function() {
	initEDACPAccordions();
};

const initEDACPAccordions = () => {
	const edacpAccordion = document.querySelectorAll( '.edacp-accordion' );
	if ( edacpAccordion ) {
		const edacpAccordionHeaders = document.querySelectorAll( '.edacp-accordion--header' );
		edacpAccordionHeaders.forEach( ( header ) => {
			header.addEventListener( 'click', () => {
				const item = header.closest( '.edacp-accordion--item' );
				item.classList.toggle( 'closed' );
				if ( header.closest( '.edacp-accordion--item' ).classList.contains( 'closed' ) ) {
					header.setAttribute( 'aria-expanded', 'false' );
				} else {
					header.setAttribute( 'aria-expanded', 'true' );
				}
			} );
		} );
	}
};
